import { defineStore } from 'pinia'

type State = {
  user: AuthenticatedUser,
  authenticated: -1 | 0 | 1, // 0 = false, 1 = true, -1 = unknown
}

export const useAuthStore = defineStore('Auth', {
  state: (): State => ({
    user: {
      id: 0,
      name: '',
      username: '',
      role: '',
    },
    authenticated: -1,
  }),
  actions: {
    setUser (user: Partial<AuthenticatedUser>) {
      this.user = { ...this.user, ...user }
    },
    setAuthenticated (authenticated: -1 | 0 | 1) {
      this.authenticated = authenticated
    },
  },
  getters: {
    isMeily (state) {
      return state.user?.role === 'Meily'
    },
  },
})
